import { useQuery } from '@tanstack/react-query'
import { type GetPaymentProfilesParams, getPaymentProfiles } from 'dashboard-experience/shared/services'

interface UseGetPaymentProfilesParams extends GetPaymentProfilesParams {
  enabled?: boolean
}

const FIVE_MINUTES_MS = 5 * 60 * 1000

export function useGetPaymentProfiles({ stoneAccountId, enabled = true }: UseGetPaymentProfilesParams) {
  return useQuery({
    queryKey: ['session-manager', 'payment-profiles', stoneAccountId] as const,
    queryFn: () => getPaymentProfiles({ stoneAccountId }),
    enabled: enabled && Boolean(stoneAccountId),
    staleTime: FIVE_MINUTES_MS,
    select: response => response.data
  })
}
